<template>
    <v-card class="custom_card pb-3">
        <v-card-text>
            <v-row dense>
                <v-col cols="12" lg="3" md="4" sm="6">
                    <v-menu v-model="date_from_menu" :close-on-content-click="false"
                            max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-text-field name="date_from" type="text" class="custom_field"
                                          :value="$Helper.methods.formatDate(search.date_from)"
                                          :label="$t('general.date_from')" outlined readonly v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="search.date_from" :locale="locale" no-title
                                       @change="date_from_menu = false">
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" lg="3" md="4" sm="6">
                    <v-menu v-model="date_to_menu" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-text-field name="date_to" type="text" class="custom_field"
                                          :value="$Helper.methods.formatDate(search.date_to)"
                                          :label="$t('general.date_to')" outlined readonly v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="search.date_to" :locale="locale" no-title
                                       @change="date_to_menu = false">
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" lg="6" md="4" sm="12" class="d-flex justify-end mb-5">
                    <v-btn color="primary" class="submit_button mr-2" dark @click="setCurrentDay">
                        {{$t('general.day')}}
                    </v-btn>
                    <v-btn color="primary" class="submit_button" dark @click="setLastMonth">
                        {{$t('general.month')}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <slot name="content"></slot>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            loading: {type: Boolean, default: false}
        },
        data: () => ({
            date_from_menu: false,
            date_to_menu: false,
            search: {
                date_from: null,
                date_to: null
            }
        }),
        computed: {
            locale() {
                return this.$i18n.locale;
            }
        },
        mounted() {
            this.setCurrentDay();
        },
        watch: {
            search: {
                handler(val) {
                    this.$emit('criteria-changed', this.$Helper.methods.createSearchFilters(Object.assign({}, val)));
                },
                deep: true
            },
        },
        methods: {
            // set current day in date pickers
            setCurrentDay() {
                let date = new Date();
                this.search.date_to = date.toISOString().substring(0, 10);
                this.search.date_from = date.toISOString().substring(0, 10);
            },
            // set last month in date pickers
            setLastMonth() {
                let date = new Date();
                this.search.date_to = date.toISOString().substring(0, 10);
                this.search.date_from = `${date.getFullYear()}-${date.getMonth() + 1}-01`;
            }
        }
    }
</script>